"use client";

import { c as _c } from "react/compiler-runtime";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import clsx from "clsx";
import { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import MemesQuickVoteDropHeader from "./MemesQuickVoteDropHeader";
import useMemesQuickVotePreviewSwipe from "./useMemesQuickVotePreviewSwipe";
const MOBILE_SWIPE_CENTER_SLIDE_INDEX = 1;
interface MemesQuickVotePreviewProps {
  readonly drop: ExtendedDrop;
  readonly isBusy: boolean;
  readonly isMobile: boolean;
  readonly remainingCount: number;
  readonly swipeVoteAmount: number | null;
  readonly uncastPower: number | null;
  readonly votingLabel: string | null;
  readonly onAdvanceStart: () => void;
  readonly onSkip: () => void;
  readonly onVoteWithSwipe: () => void;
}
function MemesQuickVotePreviewContent(t0) {
  const $ = _c(65);
  const {
    drop,
    isBusy,
    isMobile,
    remainingCount,
    swipeVoteAmount,
    uncastPower,
    votingLabel,
    onAdvanceStart,
    onSkip,
    onVoteWithSwipe
  } = t0;
  const title = drop.metadata.find(_temp)?.data_value ?? "Untitled submission";
  const description = drop.metadata.find(_temp2)?.data_value ?? "";
  let t1;
  if ($[0] !== drop.parts) {
    t1 = drop.parts.at(0)?.media.at(0);
    $[0] = drop.parts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const artworkMedia = t1;
  let t2;
  bb0: {
    if (swipeVoteAmount === null) {
      t2 = null;
      break bb0;
    }
    let t3;
    if ($[2] !== swipeVoteAmount) {
      t3 = formatNumberWithCommas(swipeVoteAmount);
      $[2] = swipeVoteAmount;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = `${t3} ${votingLabel ?? "votes"}`;
  }
  const swipeHint = t2;
  const swipeInstructionText = swipeHint ? `Swipe left to skip, right to vote ${swipeHint}` : null;
  let t3;
  if ($[4] !== isBusy || $[5] !== isMobile || $[6] !== onAdvanceStart || $[7] !== onSkip || $[8] !== onVoteWithSwipe || $[9] !== swipeVoteAmount) {
    t3 = {
      isBusy,
      isMobile,
      onAdvanceStart,
      onSkip,
      onVoteWithSwipe,
      swipeVoteAmount
    };
    $[4] = isBusy;
    $[5] = isMobile;
    $[6] = onAdvanceStart;
    $[7] = onSkip;
    $[8] = onVoteWithSwipe;
    $[9] = swipeVoteAmount;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    previewCardRef,
    canUseSwiperTouchSurface,
    cardTransform,
    cardTransitionDuration,
    handleCardTransitionEnd,
    handleSwiperMove,
    handleSwiperTouchEnd,
    swipeOffset
  } = useMemesQuickVotePreviewSwipe(t3);
  const t4 = cardTransform ?? undefined;
  const t5 = isBusy && "tw-pointer-events-none tw-opacity-70";
  let t6;
  if ($[11] !== t5) {
    t6 = clsx("tw-relative tw-flex tw-h-full tw-flex-col tw-overflow-hidden tw-transition-all tw-duration-200 tw-ease-out", t5);
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = isMobile ? "pan-y" : undefined;
  let t8;
  if ($[13] !== cardTransform || $[14] !== cardTransitionDuration || $[15] !== t7) {
    t8 = {
      transform: cardTransform,
      touchAction: t7,
      transitionDuration: cardTransitionDuration
    };
    $[13] = cardTransform;
    $[14] = cardTransitionDuration;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== artworkMedia || $[18] !== swipeHint || $[19] !== swipeOffset) {
    t9 = artworkMedia ? <div className="tw-relative tw-h-[45vh] tw-shrink-0 tw-overflow-hidden tw-border-b tw-border-solid tw-border-white/5 tw-bg-black/40 md:tw-flex md:tw-h-full md:tw-w-full md:tw-items-center md:tw-justify-center md:tw-border-0"><div className="tw-flex tw-h-full tw-items-center tw-justify-center md:tw-h-full md:tw-w-full"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div><div className={clsx("tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-4 tw-z-10 tw-flex tw-items-center tw-text-sm tw-font-semibold tw-text-rose-300 tw-transition-opacity md:tw-hidden", swipeOffset < 0 ? "tw-opacity-100" : "tw-opacity-0")}>Skip</div><div className={clsx("tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-4 tw-z-10 tw-flex tw-items-center tw-text-right tw-text-sm tw-font-semibold tw-text-primary-300 tw-transition-opacity md:tw-hidden", swipeOffset > 0 ? "tw-opacity-100" : "tw-opacity-0")}>{swipeHint ? `Vote ${swipeHint}` : "Vote"}</div></div> : <div className="tw-flex tw-h-[45vh] tw-w-full tw-shrink-0 tw-items-center tw-justify-center tw-border-b tw-border-solid tw-border-white/5 tw-bg-black/30 tw-text-sm tw-text-iron-500 md:tw-h-full md:tw-border-0">Preview unavailable</div>;
    $[17] = artworkMedia;
    $[18] = swipeHint;
    $[19] = swipeOffset;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== drop) {
    t10 = <MemesQuickVoteDropHeader drop={drop} />;
    $[21] = drop;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== title) {
    t11 = <h2 className="tw-mb-2 tw-text-lg tw-font-semibold tw-leading-tight tw-tracking-tight tw-text-iron-100/85 md:tw-mb-3 md:tw-mt-4 md:tw-text-2xl">{title}</h2>;
    $[23] = title;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== description) {
    t12 = description && <p className="tw-mb-0 tw-text-sm tw-font-medium tw-leading-relaxed tw-text-iron-500">{description}</p>;
    $[25] = description;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t10 || $[31] !== t13) {
    t14 = <div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-bg-[#0a0a0a]/30 tw-px-6 tw-pt-4 md:tw-hidden"><div className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-pb-[calc(env(safe-area-inset-bottom,0px)+10.5rem)] [-ms-overflow-style:none] [scrollbar-width:none] sm:tw-pb-[calc(env(safe-area-inset-bottom,0px)+13rem)] [&::-webkit-scrollbar]:tw-hidden"><div className="tw-flex tw-flex-col tw-gap-5">{t10}{t13}</div></div></div>;
    $[30] = t10;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14 || $[34] !== t9) {
    t15 = <div data-testid="quick-vote-preview-mobile-context" className="tw-flex tw-h-full tw-flex-col md:tw-flex md:tw-min-h-0 md:tw-flex-1 md:tw-p-0">{t9}{t14}</div>;
    $[33] = t14;
    $[34] = t9;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== handleCardTransitionEnd || $[37] !== previewCardRef || $[38] !== t15 || $[39] !== t4 || $[40] !== t6 || $[41] !== t8) {
    t16 = <article ref={previewCardRef} data-testid="quick-vote-preview-card" data-quick-vote-transform={t4} className={t6} style={t8} onTransitionEnd={handleCardTransitionEnd}>{t15}</article>;
    $[36] = handleCardTransitionEnd;
    $[37] = previewCardRef;
    $[38] = t15;
    $[39] = t4;
    $[40] = t6;
    $[41] = t8;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  const previewCard = t16;
  let t17;
  if ($[43] !== swipeInstructionText) {
    t17 = swipeInstructionText && <span className="tw-sr-only">{swipeInstructionText}</span>;
    $[43] = swipeInstructionText;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== uncastPower || $[46] !== votingLabel) {
    t18 = typeof uncastPower === "number" && <span className="tw-sr-only tw-text-primary-300">{formatNumberWithCommas(uncastPower)} {votingLabel ?? "votes"} left</span>;
    $[45] = uncastPower;
    $[46] = votingLabel;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== remainingCount) {
    t19 = formatNumberWithCommas(remainingCount);
    $[48] = remainingCount;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t19) {
    t20 = <span aria-hidden="true" className="tw-rounded-full tw-border tw-border-solid tw-border-white/5 tw-bg-white/[0.03] tw-px-4 tw-py-1.5 tw-text-[13px] tw-font-bold tw-text-iron-300 tw-shadow-sm tw-backdrop-blur-md">{t19} unexplored</span>;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t17 || $[53] !== t18 || $[54] !== t20) {
    t21 = <div data-testid="quick-vote-preview-status" className="tw-sr-only">{t17}{t18}{t20}</div>;
    $[52] = t17;
    $[53] = t18;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== canUseSwiperTouchSurface || $[57] !== handleSwiperMove || $[58] !== handleSwiperTouchEnd || $[59] !== isBusy || $[60] !== previewCard) {
    t22 = <div className="tw-relative tw-min-h-0 tw-flex-1">{canUseSwiperTouchSurface ? <Swiper initialSlide={MOBILE_SWIPE_CENTER_SLIDE_INDEX} slidesPerView={1} watchOverflow={false} followFinger={false} longSwipes={false} shortSwipes={false} threshold={0} allowTouchMove={!isBusy} resistanceRatio={0} touchStartPreventDefault={false} className="tw-h-full tw-overflow-visible" onTouchMove={handleSwiperMove} onTouchEnd={handleSwiperTouchEnd}><SwiperSlide aria-hidden="true" className="tw-h-full"><div className="tw-h-px" /></SwiperSlide><SwiperSlide className="tw-h-full">{previewCard}</SwiperSlide><SwiperSlide aria-hidden="true" className="tw-h-full"><div className="tw-h-px" /></SwiperSlide></Swiper> : previewCard}</div>;
    $[56] = canUseSwiperTouchSurface;
    $[57] = handleSwiperMove;
    $[58] = handleSwiperTouchEnd;
    $[59] = isBusy;
    $[60] = previewCard;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== t21 || $[63] !== t22) {
    t23 = <div className="tw-flex tw-h-full tw-flex-col">{t21}{t22}</div>;
    $[62] = t21;
    $[63] = t22;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  return t23;
}
function _temp2(entry_0) {
  return entry_0.data_key === "description";
}
function _temp(entry) {
  return entry.data_key === "title";
}
export default function MemesQuickVotePreview(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MemesQuickVotePreviewContent key={props.drop.id} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}